import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { GlobalLoadingStore } from './global-loading.store';

export type SpinnerVariant = 'ring' | 'dash' | 'dots' | 'bar' | 'overlay';
export type SpinnerSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-mksoft-loading-spinner',
  imports: [],
  templateUrl: './loadingSpinner.html',
  styleUrl: './loadingSpinner.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinner {
  protected readonly loading = inject(GlobalLoadingStore);
  isActive = computed(() => this.loading.active());
  //protected readonly authServiceStore = authServiceStore;

  readonly variant = input<SpinnerVariant>('ring');
  readonly size = input<SpinnerSize>('md');
  readonly text = input<string>('Daten werden geladen ...'); // z.B. "Bestand wird geladen…"
  readonly subtext = input<string>('Bitte einen Moment warten');

  readonly ringSize = computed(() => {
    switch (this.size()) {
      case 'sm':
        return 'w-6 h-6 border-2';
      case 'lg':
        return 'w-16 h-16 border-4';
      default:
        return 'w-12 h-12 border-[3.5px]';
    }
  });

  readonly svgSize = computed(() => {
    switch (this.size()) {
      case 'sm':
        return 24;
      case 'lg':
        return 64;
      default:
        return 48;
    }
  });

  readonly dotSize = computed(() => {
    switch (this.size()) {
      case 'sm':
        return 'w-2 h-2';
      case 'lg':
        return 'w-4 h-4';
      default:
        return 'w-2.5 h-2.5';
    }
  });
}
